module.exports = __webpack_public_path__ + "static/media/serigrafia.d11ec5ff.jpg";